import Button from "@mui/material/Button";

import APIcon, { APIconName } from "./APIcon";

const APButton = ({
  text,
  onClick,
  variant = "outlined",
  color = "primary",
  textColor,
  icon,
  endIcon,
  type = "button",
  size = "large",
  disabled = false,
  noWrap = false,
}: {
  text: string;
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  variant?: "outlined" | "contained";
  color?: "primary" | "secondary" | "tertiaryGreen" | "neutralWhite" | "error";
  textColor?: "primary" | "secondary" | "tertiaryGreen" | "neutralWhite";
  icon?: APIconName;
  endIcon?: APIconName;
  type?: "button" | "submit" | "reset";
  size?: "small" | "medium" | "large";
  disabled?: boolean;
  noWrap?: boolean;
}) => {
  return (
    <Button
      color={color}
      variant={variant}
      disableElevation={true}
      onClick={onClick}
      type={type}
      startIcon={icon ? <APIcon name={icon} /> : undefined}
      endIcon={endIcon ? <APIcon name={endIcon} /> : undefined}
      size={size}
      sx={{
        color: textColor ? `${textColor}.main` : undefined,
        whiteSpace: noWrap ? "nowrap" : undefined,
      }}
      disabled={disabled}
    >
      {text}
    </Button>
  );
};

export default APButton;
